export default __webpack_public_path__ + "a6a52145c863d9c61e9f63ad49c32b87.png";